var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container-fluid',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"sm":"12","lg":"11"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('NoPage')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }